import { Injectable } from '@angular/core';
import { ResourcerService } from 'src/app/api/services';
import { version } from '../../../../../package.json';

@Injectable({
  providedIn: 'root',
})
export class TekstResourceService {
  tekstResourcer: { [key: string]: string } = {};

  initialize(): Promise<void> {
    return this.resourcerService
      .getTekster(version)
      .toPromise()
      .then(tekster => {
        this.tekstResourcer = tekster;
      });
  }

  constructor(private resourcerService: ResourcerService) {}

  /**
   * Gets the tekstresource with key
   */
  getTekstResource(key: string): string {
    if (key === undefined || this.tekstResourcer[key] === undefined) {
      return `TEKSTRESOURCE ${key} IKKE FUNDET!`;
    }
    return this.tekstResourcer[key];
  }
}
